import styled from "styled-components";
import { tablet } from "../../utils/breakpoints";
import logoSrc from "../../assets/images/noire-logo-white.png";
import { Link } from "react-router-dom";

export const PageContainer = styled.div`
  width: 100%;
  height: 100vh;
  background-color: black;
  color: white;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-areas: "left center right";
  overflow-y: auto;
  ${tablet} {
    grid-template-columns: 1fr;
    grid-template-areas: "center";
  }
  border-style: solid;
`;

export const Page = styled.div`
  display: grid;
  grid-area: center;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-areas:
    "header header header"
    "main main main"
    "footer footer footer";
`;

export const HeaderContainer = styled.div`
  grid-area: header;
  display: grid;
  justify-content: center;
  padding-top: 35px;
  justify-items: center;
  img {
    width: 50px;
  }
`;

export const FormContainer = styled.div`
  display: grid;
  grid-area: body;
  justify-content: center;
  grid-template-columns: 80%;
  justify-items: center;
  button[type="submit"] {
    width: 40%;
    min-height: 30px;
  }
  input {
    width: 90%;
    background-color: black;
    color: white;
    margin-bottom: 10%;
    min-height: 30px;
    outline: 0;
    border-width: 0 0 2px;
  }
  ::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: white;
    opacity: 1; /* Firefox */
  }
`;

export const Header = () => (
  <HeaderContainer>
    <Link to="/">
      <img alt="header" src={logoSrc}></img>
    </Link>
  </HeaderContainer>
);
